module.exports = __webpack_public_path__ + "img/voucher-payments.6af1dcd.png";